import React, { useState } from 'react';
import CustomButton from '../reusable/CustomButton';
import DataApprovalWorkflowModal from './DataApprovalWorkflowModal';
import ReportIssueModal from './ReportIssueModal';
import ApproveDataQcModal from './ApproveDataQcModal';
import { WorkflowTransitionResponse } from '../../services/workflowService';
import './DataQcActionButtons.css';

interface DataQcActionButtonsProps {
  updateWorkflowStatusFromTransition: (transitionResponse: WorkflowTransitionResponse) => void;
}

const DataQcActionButtons = ({ updateWorkflowStatusFromTransition }: DataQcActionButtonsProps) => {
  const [isWorkflowModalOpen, setIsWorkflowModalOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);

  const handleLearnMoreClick = () => {
    setIsWorkflowModalOpen(true);
  };

  const handleCloseWorkflowModal = () => {
    setIsWorkflowModalOpen(false);
  };

  const handleRejectClick = () => {
    setIsReportModalOpen(true);
  };

  const handleCloseReportModal = () => {
    setIsReportModalOpen(false);
  };

  const handleApproveClick = () => {
    setIsApproveModalOpen(true);
  };

  const handleCloseApproveModal = () => {
    setIsApproveModalOpen(false);
  };

  const handleReportSuccess = (transitionResponse: WorkflowTransitionResponse) => {
    updateWorkflowStatusFromTransition(transitionResponse);
    setIsReportModalOpen(false);
  };

  const handleApproveSuccess = (transitionResponse: WorkflowTransitionResponse) => {
    updateWorkflowStatusFromTransition(transitionResponse);
    setIsApproveModalOpen(false);
  };

  return (
    <>
      <div className="data-qc-action-buttons-container">
        <span className="data-qc-question-text">Does this data look right?</span>
        <div className="data-qc-buttons-group">
          <CustomButton variant="secondary" buttonText="No, something looks wrong" buttonAction={handleRejectClick} />
          <CustomButton variant="primary" buttonText="Yes, it looks great!" buttonAction={handleApproveClick} />
          <button className="data-qc-learn-more-link" onClick={handleLearnMoreClick}>
            Learn more
          </button>
        </div>
      </div>
      <DataApprovalWorkflowModal isOpen={isWorkflowModalOpen} onClose={handleCloseWorkflowModal} />
      <ReportIssueModal isOpen={isReportModalOpen} onClose={handleCloseReportModal} onSuccess={handleReportSuccess} />
      <ApproveDataQcModal
        isOpen={isApproveModalOpen}
        onClose={handleCloseApproveModal}
        onSuccess={handleApproveSuccess}
      />
    </>
  );
};

export default DataQcActionButtons;
